import styled from "styled-components";
import { useContext } from "react";
import { TableInstanceContext } from "../EnvResultsTable";

const Row = styled.tr`
  border-bottom: 1px solid var(--color-table-border);

  &:nth-child(even) {
    background: var(--color-table-even);
  }
`;

const Cell = styled.td`
  padding: 10px;
  font-size: 14px;
  color: var(--color-text-body);
  overflow-wrap: anywhere;
`;

const renderTableCell = (cell, deletingRowId, setDeletingRowId) => {
  // Pass props only to the "icons" cell
  if (cell.column.id === "icons") {
    return (
        <Cell {...cell.getCellProps()} className={cell.column.id}>
          {cell.render("Cell", { deletingRowId, setDeletingRowId })}
        </Cell>
    );
  }
  return (
      <Cell {...cell.getCellProps()} className={cell.column.id}>
        {cell.render("Cell")}
      </Cell>
  );
};

const renderTableRow = (row, prepareRow, deletingRowId, setDeletingRowId) => {
  prepareRow(row);
  return (
      <Row {...row.getRowProps()}>
        {row.cells.map((cell) =>
            renderTableCell(cell, deletingRowId, setDeletingRowId)
        )}
      </Row>
  );
};

const TableBody = ({ deletingRowId, setDeletingRowId }) => {
  const { tableInstance } = useContext(TableInstanceContext);
  const { getTableBodyProps, page, prepareRow } = tableInstance;

  return (
      <tbody {...getTableBodyProps()}>
      {page.map((row) =>
          renderTableRow(row, prepareRow, deletingRowId, setDeletingRowId)
      )}
      </tbody>
  );
};


export default TableBody;
